import { render, staticRenderFns } from "./ExpandableImage.vue?vue&type=template&id=767efdf6&lang=pug"
import script from "./ExpandableImage.vue?vue&type=script&lang=js"
export * from "./ExpandableImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports